export const colorPrimary: string = '#00b96b'

export const backgroundColor: string = 'white'

export const colorSecondary: string = 'lightgreen'

export const colorText: string = 'black'
export const colorTextSecondary: string = 'white'

export const fontFamily: string = 'Roboto'